class OrderedPageSelectorObserver {
    constructor() {
        this.config = { childList: true, attributes: true, subtree: true };
        this.watchTable = {};
        this.itemsClass = '.ktc-multi-page-box li';
        this.updateSelected = (hiddenNode, componentNode) => {
            if (!hiddenNode.value) {
                return;
            }
            window.OrderedPageSelectorObserver.watchTable[componentNode.id] = false;
            const selected = JSON.parse(hiddenNode.value);
            const items = componentNode.querySelectorAll(this.itemsClass);
            items.forEach((v, i) => {
                const selectedItem = selected.find((t) => v.title === t.nodeAliasPath);
                selectedItem.order = i;
            });
            hiddenNode.value = JSON.stringify(selected);
        };
        this.registerDragEvents = (target, componentNode) => {
            let items = componentNode.querySelectorAll(this.itemsClass);
            let current = null;
            const hiddenSelectedNode = target.nodeName === 'INPUT' ? target : target.querySelector('input[type="hidden"]');
            items.forEach((item) => {
                item.draggable = true;
                item.ondragstart = (e) => {
                    current = item;
                    item.classList.add('active');
                };
                item.ondropenter = (e) => {
                    e.preventDefault();
                    item.classList.add('over');
                };
                item.ondragover = (e) => {
                    e.preventDefault();
                    item.classList.add('over');
                };
                item.ondragleave = (e) => {
                    item.classList.remove('over');
                };
                item.ondragend = (e) => {
                    item.classList.remove('active');
                    items.forEach((i) => {
                        i.classList.remove('over');
                    });
                };
                item.ondrop = (e) => {
                    e.preventDefault();
                    if (item !== current) {
                        let currentPosition = 0;
                        let droppedPosition = 0;
                        for (let it = 0; it < items.length; it++) {
                            if (current === items[it]) {
                                currentPosition = it;
                            }
                            if (item === items[it]) {
                                droppedPosition = it;
                            }
                        }
                        if (currentPosition < droppedPosition) {
                            item.parentNode.insertBefore(current, item.nextSibling);
                        }
                        else {
                            item.parentNode.insertBefore(current, item);
                        }
                    }
                    item.classList.remove('active');
                    items.forEach((i) => {
                        i.classList.remove('over');
                    });
                    items = componentNode.querySelectorAll(this.itemsClass);
                    window.OrderedPageSelectorObserver.updateSelected(hiddenSelectedNode, componentNode);
                };
            });
            window.OrderedPageSelectorObserver.updateSelected(hiddenSelectedNode, componentNode);
        };
        this.callback = (mutationsList, componentNode) => {
            for (const mutation of mutationsList) {
                if (window.OrderedPageSelectorObserver.watchTable[componentNode.id] !== undefined && !window.OrderedPageSelectorObserver.watchTable[componentNode.id]) {
                    window.OrderedPageSelectorObserver.watchTable[componentNode.id] = true;
                    break;
                }
                if (mutation.type === 'attributes' && mutation.target && (mutation.target.nodeName === 'INPUT' || mutation.target.nodeName === 'KENTICO-PAGE-SELECTOR-FORM-COMPONENT')) {
                    window.OrderedPageSelectorObserver.registerDragEvents(mutation.target, componentNode);
                }
                if (mutation.type === 'childList' && mutation.target instanceof HTMLElement && mutation.target.classList.contains('ktc-form-control')) {
                    for (const removedNode of mutation.removedNodes) {
                        if (removedNode instanceof HTMLElement && removedNode.classList.contains('ktc-show-all-items-container')) {
                            const target = mutation.target instanceof HTMLElement && mutation.target.closest('kentico-page-selector-form-component');
                            window.OrderedPageSelectorObserver.registerDragEvents(target, componentNode);
                        }
                    }
                }
            }
        };
        this.getObserver = (selector) => {
            const componentNode = document.querySelector(selector);
            const observer = new MutationObserver((mutations) => this.callback(mutations, componentNode));
            observer.observe(componentNode, this.config);
            return observer;
        };
    }
}
export default OrderedPageSelectorObserver;
